module.exports = __webpack_public_path__ + "static/img/logo.79fce836.png";